import { useEffect, useState } from 'react';

const matches = (query) =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;

/**
 * Whether a CSS media query currently matches, updating as it changes.
 * For the rare case where a layout needs different markup per breakpoint, not
 * just different styles; prefer Tailwind's responsive prefixes otherwise.
 * @param {string} query - e.g. "(min-width: 1024px)" for Tailwind's lg.
 */
export default function useMediaQuery(query) {
  const [isMatch, setIsMatch] = useState(() => matches(query));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const list = window.matchMedia(query);
    const onChange = () => setIsMatch(list.matches);
    onChange();
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return isMatch;
}
